import { useT } from "../i18n";

// Static, SEO-relevant content for the home page — describes the service in the active language.
export function AboutSection() {
  const t = useT();
  return (
    <section className="section about">
      <h2>{t("about.h2")}</h2>
      <p>{t("about.intro")}</p>

      <h3>{t("about.how_h")}</h3>
      <ol className="about-steps">
        <li>{t("about.how1")}</li>
        <li>{t("about.how2")}</li>
        <li>{t("about.how3")}</li>
      </ol>

      <h3>{t("about.feat_h")}</h3>
      <ul className="about-feats">
        <li>{t("about.feat1")}</li>
        <li>{t("about.feat2")}</li>
        <li>{t("about.feat3")}</li>
        <li>{t("about.feat4")}</li>
      </ul>

      <h3>{t("about.faq_h")}</h3>
      <p dangerouslySetInnerHTML={{ __html: t("about.faq1") }} />
      <p dangerouslySetInnerHTML={{ __html: t("about.faq2") }} />
      <p dangerouslySetInnerHTML={{ __html: t("about.faq3") }} />
    </section>
  );
}
